import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

export const filterDataMap = {
  'fundMetaData.risk': [
    {
      label: 'Very High',
      key: 'Very High Risk',
    },
    {
      label: 'High',
      key: 'High Risk',
    },
    {
      label: 'Moderately High',
      key: 'Moderately High Risk',
    },
    {
      label: 'Moderate',
      key: 'Moderate Risk',
    },
    {
      label: 'Low to Moderate',
      key: 'Low to Moderate Risk',
    },
    {
      label: 'Low',
      key: 'Low Risk',
    },
    // {
    //   label: 'Medium Risk',
    //   key: 'Medium Risk',
    // },
  ],
  fundType: [
    {
      label: 'Tax Savings',
      key: 'ELSS',
    },
    {
      label: 'Equity',
      key: 'Equity',
      'categoryFilter.categoryFilterValue': [
        {
          label: 'Large Cap',
          key: 'Large Cap',
        },
        {
          label: 'Mid Cap',
          key: 'Mid Cap',
        },
        {
          label: 'Small Cap',
          key: 'Small Cap',
        },
        {
          label: 'Large & Mid Cap',
          key: 'Large and Mid Cap',
        },
        {
          label: 'MultiCap',
          key: 'Multi Cap',
        },
        {
          label: 'Focused',
          key: 'Focused',
        },
        {
          label: 'Value',
          key: 'Value',
        },
        {
          label: 'International- Global Other',
          key: 'International',
        },
        {
          label: 'Dividend Yield',
          key: 'Dividend Yield',
        },
        {
          label: 'Contra',
          key: 'Contra',
        },
        {
          label: 'Financial services',
          key: 'Financial Services',
        },
        {
          label: 'FMCG',
          key: 'FMCG',
        },
        {
          label: 'Technology',
          key: 'Technology',
        },
        {
          label: 'Infrastructure',
          key: 'Infrastructure',
        },
        {
          label: 'Healthcare',
          key: 'Healthcare',
        },
        {
          label: 'Consumption',
          key: 'Consumption',
        },
        {
          label: 'Others',
          key: 'Other',
        },
      ],
    },
    {
      label: 'Index',
      key: 'Index',
      'categoryFilter.categoryFilterValue': [
        {
          label: 'Sensex',
          key: 'Sensex',
        },
        {
          label: 'Nifty',
          key: 'Nifty',
        },
      ],
    },
    {
      label: 'Debt',
      key: 'Debt',
      'categoryFilter.categoryFilterValue': [
        {
          label: 'Overnight',
          key: 'Overnight',
        },
        {
          label: 'Liquid',
          key: 'Liquid',
        },
        {
          label: 'Ultrashort',
          key: 'Ultra Short Duration',
        },
        {
          label: 'Low Duration',
          key: 'Low Duration',
        },
        {
          label: 'Money Market',
          key: 'Money Market',
        },
        {
          label: 'Short',
          key: 'Short Duration',
        },
        {
          label: 'Medium',
          key: 'Medium Duration',
        },
        {
          label: 'Medium-to-Long',
          key: 'Medium to Long Duration',
        },
        {
          label: 'Long',
          key: 'Long Duration',
        },
        {
          label: 'Banking & PSU',
          key: 'Banking and PSU',
        },
        {
          label: 'Corporate Bonds',
          key: 'Corporate Bond',
        },
        {
          label: 'Dynamic Bonds',
          key: 'Dynamic Bond',
        },
        {
          label: 'Gilt/ Government Bond',
          key: 'Gilt / Government Bond',
        },
        {
          label: '10 Yr Government Bond',
          key: '10 yr Government Bond',
        },
        {
          label: 'Credit Risk',
          key: 'Credit Risk',
        },
        {
          label: 'Floating Rate',
          key: 'Floating Rate',
        },
      ],
    },
    {
      label: 'Hybrid',
      key: 'Hybrid',
      'categoryFilter.categoryFilterValue': [
        {
          label: 'Aggressive',
          key: 'Aggressive Allocation',
        },
        {
          label: 'Conservative',
          key: 'Conservative Allocation',
        },
        {
          label: 'Equity Savings',
          key: 'Equity Savings',
        },
        {
          label: 'Fund Of Funds',
          key: 'Fund Of Funds',
        },
        {
          label: 'DAAS',
          key: 'Dynamic Asset Allocation',
        },
        {
          label: 'Multiasset',
          key: 'Multi Asset Allocation',
        },
        {
          label: 'Arbitrage',
          key: 'Arbitrage Fund',
        },
        {
          label: 'Retirement',
          key: 'Retirement',
        },
        {
          label: 'Children',
          key: 'Children',
        },
      ],
    },
    {
      label: 'Commodities',
      key: 'Metals',
    },
  ],

  issuingAuthority: [
    {
      label: 'ADITYA BIRLA SUN LIFE',
      key: 'ADITYA BIRLA SUN LIFE MUTUAL FUND',
    },
    { label: 'AXIS', key: 'AXIS MUTUAL FUND' },
    { label: 'BARODA', key: 'BARODA MUTUAL FUND' },
    { label: 'BNP PARIBAS', key: 'BNP PARIBAS MUTUAL FUND' },
    { label: 'BOI AXA', key: 'BOI AXA MUTUAL FUND' },
    { label: 'CANARA ROBECO', key: 'CANARA ROBECO MUTUAL FUND' },
    { label: 'DSP', key: 'DSP MUTUAL FUND' },
    { label: 'EDELWEISS', key: 'EDELWEISS MUTUAL FUND' },
    { label: 'FRANKLIN TEMPLETON', key: 'FRANKLIN TEMPLETON MUTUAL FUND' },
    { label: 'HDFC', key: 'HDFC MUTUAL FUND' },
    { label: 'HSBC', key: 'HSBC MUTUAL FUND' },
    { label: 'ICICI PRUDENTIAL', key: 'ICICI PRUDENTIAL MUTUAL FUND' },
    { label: 'IDBI', key: 'IDBI MUTUAL FUND' },
    { label: 'IDFC', key: 'IDFC MUTUAL FUND' },
    { label: 'IIFL', key: 'IIFL Mutual Fund' },
    { label: 'INVESCO', key: 'INVESCO MUTUAL FUND' },
    { label: 'ITI', key: 'ITI MUTUAL FUND' },
    { label: 'JM FINANCIAL', key: 'JM MUTUAL FUND' },
    { label: 'KOTAK MAHINDRA', key: 'KOTAK MAHINDRA MUTUAL FUND' },
    { label: 'L&T', key: 'L&T MUTUAL FUND' },
    { label: 'LIC', key: 'LIC MUTUAL FUND' },
    { label: 'MAHINDRA MANULIFE', key: 'Mahindra Manulife Mutual Fund' },
    { label: 'MIRAE ASSET', key: 'MIRAE ASSET MUTUAL FUND' },
    { label: 'MOTILAL OSWAL', key: 'MOTILAL OSWAL MUTUAL FUND' },
    { label: 'NAVI', key: 'NAVI MUTUAL FUND' },
    { label: 'NIPPON', key: 'NIPPON INDIA MUTUAL FUND' },
    { label: 'PGIM', key: 'PGIM MUTUAL FUND' },
    { label: 'PPFAS', key: 'PPFAS Mutual Fund' },
    { label: 'PRINCIPAL', key: 'PRINCIPAL MUTUAL FUND' },
    { label: 'QUANT', key: 'QUANT MUTUAL FUND' },
    { label: 'QUANTUM', key: 'QUANTUM MUTUAL FUND' },
    { label: 'SBI', key: 'SBI MUTUAL FUND' },
    { label: 'SHRIRAM', key: 'SHRIRAM MUTUAL FUND' },
    { label: 'SUNDARAM', key: 'SUNDARAM MUTUAL FUND' },
    { label: 'TATA', key: 'TATA MUTUAL FUND' },
    { label: 'TAURUS', key: 'TAURUS MUTUAL FUND' },
    { label: 'TRUST', key: 'TRUST MUTUAL FUND' },
    { label: 'UNION', key: 'UNION MUTUAL FUND' },
    { label: 'UTI', key: 'UTI MUTUAL FUND' },
    { label: 'YES', key: 'YES MUTUAL FUND' },
  ],

  subCategory: [
    { label: 'ELSS (Tax Savings)', key: 'ELSS (Tax Savings)' },
    { label: 'Large-Cap', key: 'Large-Cap' },
    { label: 'Mid-Cap', key: 'Mid-Cap' },
    { label: 'Dynamic Bond ', key: 'Dynamic Bond ' },
    { label: 'Small-Cap', key: 'Small-Cap' },
    { label: 'Ultra Short Duration', key: 'Ultra Short Duration' },
    { label: 'Balanced Allocation', key: 'Balanced Allocation' },
    { label: 'Multi-Cap', key: 'Multi-Cap' },
    { label: 'Flexicap', key: 'Flexicap' },
    { label: 'Short Duration', key: 'Short Duration' },
    { label: 'Liquid', key: 'Liquid' },
    { label: 'Medium to Long Duration', key: 'Medium to Long Duration' },
    { label: 'Moderate Allocation', key: 'Moderate Allocation' },
    { label: 'Corporate Credit', key: 'Corporate Credit' },
    { label: 'Credit Risk', key: 'Credit Risk' },
    { label: 'Conservative Allocation', key: 'Conservative Allocation' },
    { label: 'Short-Term Government Bond', key: 'Short-Term Government Bond' },
    {
      label: 'Sector - Financial Services',
      key: 'Sector - Financial Services',
    },
    { label: 'Sector - Infrastructure', key: 'Sector - Infrastructure' },
    { label: 'Global - Other', key: 'Global - Other' },
    { label: 'Arbitrage Fund', key: 'Arbitrage Fund' },
    { label: 'Equity - Other', key: 'Equity - Other' },
    { label: 'Government Bond', key: 'Government Bond' },
    {
      label: 'Intermediate Government Bond',
      key: 'Intermediate Government Bond',
    },
    { label: 'Short-Term Bond', key: 'Short-Term Bond' },
    { label: 'Sector - Precious Metals', key: 'Sector - Precious Metals' },
    { label: 'Equity Savings', key: 'Equity Savings' },
    { label: 'Multi Asset Allocation', key: 'Multi Asset Allocation' },
    { label: '10 yr Government Bond', key: '10 yr Government Bond' },
    { label: 'Dynamic Asset Allocation', key: 'Dynamic Asset Allocation' },
    { label: 'Sector - FMCG', key: 'Sector - FMCG' },
    { label: 'Sector - Technology', key: 'Sector - Technology' },
    { label: 'Sector - Healthcare', key: 'Sector - Healthcare' },
    { label: 'Sector - Energy', key: 'Sector - Energy' },
  ],

  'fundMetaData.exitLoad.percentage': [
    {
      label: 'Yes',
      key: '-0',
    },

    {
      label: 'No',
      key: '0',
    },
  ],

  'fundMetaData.morningStarRating': [
    {
      label: '5 Star',
      key: '5',
    },

    {
      label: '4 Star',
      key: '4',
    },
    {
      label: '3 Star',
      key: '3',
    },
    {
      label: '2 Star',
      key: '2',
    },
    {
      label: '1 Star',
      key: '1',
    },
  ],
};

export const filterCategoryMap = [
  {
    category: 'fundType',
    key: 'fundType',
    label: 'Category',
  },
  {
    category: 'categoryFilter.categoryFilterValue',
    key: 'categoryFilter.categoryFilterValue',
    label: 'SubCategory',
  },
  {
    category: 'issuingAuthority',
    key: 'issuingAuthority',
    label: 'Fund Houses',
  },
  {
    category: 'fundMetaData.exitLoad.percentage',
    key: 'fundMetaData.exitLoad.percentage',
    label: 'Exit Load',
  },
  {
    category: 'fundMetaData.risk',
    key: 'fundMetaData.risk',
    label: 'Risk',
  },
  {
    category: 'fundMetaData.morningStarRating',
    key: 'fundMetaData.morningStarRating',
    label: 'Rating',
  },
];

export const searchSortField = {
  name: 'sortby',
  type: 'select',
  isInvalid: false,
  required: false,
  className: 'large-4 columns',
  hideEmpty: true,
  labelName: '',
  id: 'sortby',
};

export const stagingAlgoliaIndex = 'clearsave_all_funds_staging_with_nfo';
export const algoliaIndex = 'clearsave_all_funds_with_nfo';

export const searchSortOptions = [
  {
    label: '3 Year Returns',
    value:
      publicRuntimeConfig.env === 'development' ||
      publicRuntimeConfig.env === 'qa'
        ? stagingAlgoliaIndex
        : algoliaIndex,
  },
  {
    label: '5 Year Returns',
    value: 'clearsave_all_funds_5year_returns_desc',
  },
  {
    label: 'Min SIP Amount',
    value: 'clearsave_all_funds_min_sip_aesc',
  },
  {
    label: 'Min Lumpsum Amount',
    value: 'clearsave_all_funds_min_amount_aesc',
  },
];

export const replicaFilterMap = {
  min_sip_aesc: 'minSipAmount>0',
  min_amount_aesc: 'minAmount>0',
};



// WEBPACK FOOTER //
// ./constants/searchConstants.ts